import List from '@service-victoria/component-library/components/List';
import Text from '@service-victoria/component-library/components/Text';
import React from 'react';

import * as Styled from './styled';

export default function HowItWorks() {
  return (
    <>
      <Text.Heading.H3 fontWeight={600}>Redeeming vouchers</Text.Heading.H3>
      <Styled.ListWrapper>
        <List
          type='number'
          items={[
            'Log in using the Service Victoria account your organisation created as a Get Active Kids activity provider.',
            'Enter the voucher details individually, or upload a CSV file for bulk redemption (we’ll provide a sample file for you to edit)',
            'Your request will be reviewed.',
            'If approved, you’ll receive the funds into your organisation’s nominated bank account.'
          ]}
        />
      </Styled.ListWrapper>
      <Text.Heading.H3 fontWeight={600}>Making changes and updates</Text.Heading.H3>
      <Text.Body>You can log in and update your organisation’s details, including:</Text.Body>
      <Styled.ListWrapper>
        <List type='disc' items={['name', 'phone number', 'email address', 'activity type']} />
      </Styled.ListWrapper>
    </>
  );
}
